import moment from 'moment';

const getRange = (startDate, endDate, type) => {
    let fromDate = moment(startDate);
    let toDate = moment(endDate);
    let diff = toDate.diff(fromDate, type);
    let range = [];

    for (let i = 0; i < diff; i++) {
        range.push(moment(startDate).add(i, type));
    }

    return range;
};

export const completedSurveysMapper = (responses, startDate, endDate) => {
    let passCounter = {};
    let passSeries = [];
    let failCounter = {};
    let failSeries = [];
    let range;
    let dates;
    if (startDate === endDate) {
        range = getRange(
            moment(startDate).startOf('day'),
            moment(endDate).endOf('day'),
            'hours'
        );
        dates = range.map((date) => {
            return date.format('hh:mm A');
        });

        for (let d in range) {
            let date = range[d].format('hh');
            passCounter[date] = 0;
            failCounter[date] = 0;
        }

        for (let r in responses) {
            let time = moment(responses[r].Survey_Time.value).format('hh:mm A');
            let status = responses[r].Passed;
            if (status === 'true') {
                if (passCounter[time.substring(0, 2)]) {
                    passCounter[time.substring(0, 2)]++;
                } else {
                    passCounter[time.substring(0, 2)] = 1;
                }
            }
            if (status === 'false') {
                if (failCounter[time.substring(0, 2)]) {
                    failCounter[time.substring(0, 2)]++;
                } else {
                    failCounter[time.substring(0, 2)] = 1;
                }
            }
        }
    } else {
        range = getRange(startDate, endDate, 'days');
        dates = range.map((date) => {
            return date.format('MM/DD');
        });

        for (let d in range) {
            let date = range[d].format('MM/DD');
            passCounter[date] = 0;
            failCounter[date] = 0;
        }

        for (let r in responses) {
            let time = moment(responses[r].Survey_Time.value).format('MM/DD');
            let status = responses[r].Passed;
            if (status === 'true') {
                if (passCounter[time]) {
                    passCounter[time]++;
                } else {
                    passCounter[time] = 1;
                }
            }
            if (status === 'false') {
                if (failCounter[time]) {
                    failCounter[time]++;
                } else {
                    failCounter[time] = 1;
                }
            }
        }
    }

    for (let i in passCounter) {
        passSeries.push(passCounter[i]);
    }

    for (let i in failCounter) {
        failSeries.push(failCounter[i]);
    }

    return {
        labels: dates,
        series: [passSeries, failSeries],
    };
};

export const failedSurveysMapper = (responses, startDate, endDate) => {
    let failCounter = {};
    let failSeries = [];
    let range;
    let dates;
    if (startDate === endDate) {
        range = getRange(
            moment(startDate).startOf('day'),
            moment(endDate).endOf('day'),
            'hours'
        );
        dates = range.map((date) => {
            return date.format('hh:mm A');
        });
        for (let d in range) {
            let date = range[d].format('hh');
            failCounter[date] = 0;
        }
        for (let r in responses) {
            let time = moment(responses[r].Survey_Time.value).format('hh:mm A');
            let status = responses[r].Passed;

            if (status === 'false') {
                if (failCounter[time.substring(0, 2)]) {
                    failCounter[time.substring(0, 2)]++;
                } else {
                    failCounter[time.substring(0, 2)] = 1;
                }
            }
        }
    } else {
        range = getRange(startDate, endDate, 'days');
        dates = range.map((date) => {
            return date.format('MM/DD');
        });

        for (let d in range) {
            let date = range[d].format('MM/DD');
            failCounter[date] = 0;
        }

        for (let r in responses) {
            let time = moment(responses[r].Date.value).format('MM/DD');
            let status = responses[r].Passed;

            if (status === 'false') {
                if (failCounter[time]) {
                    failCounter[time]++;
                } else {
                    failCounter[time] = 1;
                }
            }
        }
    }

    for (let i in failCounter) {
        failSeries.push(failCounter[i]);
    }

    return {
        labels: dates,
        series: [failSeries],
    };
};
